<template>
  <transition-group
    name="staggered-fade"
    tag="div"
    :css="false"
    appear
    @before-enter="beforeEnter"
  >
    <v-row
      v-for="item in items"
      :key="item.title"
      class="processing-summary-items ma-0"
    >
      <v-col
        cols="6"
        class="text-right"
      >
        <div class="subtitle-1 text-title pr-4">{{item.title}}</div>
      </v-col>
      <v-col
        cols="6"
        class="text-left"
      >
        <div class="subtitle-2 text--black font-weight-black pl-4">{{item.value | displayValue}}</div>
      </v-col>
    </v-row>
  </transition-group>
</template>

<script>
  import anime from "animejs"

  export default {
    name: "ProcessingSummaryItems",
    props: {
      items: Array,
    },
    data: () => ({
      idx: 0,
    }),
    methods: {
      beforeEnter: function (el) {
        el.style.opacity = 0
        const enterDelay = this.idx * 150
        this.idx += 1

        anime({
          targets: el,
          duration: 300,
          opacity: 1,
          easing: "easeOutCubic",
          delay: enterDelay,
        })
      },
    },
    filters: {
      displayValue(value) {
        if (typeof value === "boolean")
          return value ? "Sim" : "Não"

        return value
      },
    },
  }
</script>

<style scoped lang="scss">
  .processing-summary-items:nth-child(even) {
    background: #f7f7f7;
  }

  .text-title {
    color: #868686;
  }
</style>
